import axios from "axios";
import { BE_HOST } from "../../config/config";
import { axiosInstance } from "../../utils/axiosInterceptor";
import { store } from "../store";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_CLEAR_STATE,
  USER_ROLE_REQUEST,
  USER_ROLE_SUCCESS,
  USER_ROLE_FAIL,
  USER_TOKEN,
  SET_SESSION_ID,
} from "../types";

export const userAuthAction =
  (input, callback) => async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: USER_LOGIN_REQUEST });

    try {
      // Get device and browser information
      const deviceInfo = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        deviceType: /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(
          navigator.userAgent
        )
          ? "Mobile"
          : "Desktop",
      };

      const { data } = await axios.get(`${BE_HOST}/users/authenticate`, {
        headers: {
          Authorization: state?.userAuth?.token,
          "X-Device-Info": JSON.stringify(deviceInfo),
        },
      });
      console.log(data, "dataaaaaaaaaaaa");

      dispatch({ type: USER_LOGIN_SUCCESS, payload: data });

      if (data.data.sessionId) {
        dispatch({ type: SET_SESSION_ID, payload: data.data.sessionId });
      }

      callback?.(true);
      localStorage.setItem("userInfo", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: error,
      });
      callback?.(true);
      console.log(error, "user auth error");
    }
  };

// Add logout action to update session end time
export const logoutAction = () => async (dispatch) => {
  try {
    const userInfo = localStorage.getItem("userInfo");
    const sessionId = store.getState().userAuth.sessionId;
    const token = userInfo ? JSON.parse(userInfo).data.token : null;
    console.log(token, "token");
    console.log(sessionId, "sessonId");
    console.log(userInfo, "userInfo");
    if (token) {
      await axios.get(`${BE_HOST}/auth/signout`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Session-ID": sessionId,
        },
      });
    }

    localStorage.removeItem("userInfo");
    dispatch({ type: USER_LOGIN_CLEAR_STATE });
    dispatch({ type: SET_SESSION_ID, payload: null });
    window.location.href = "/login";
  } catch (error) {
    console.error("Logout error:", error);
    localStorage.removeItem("userInfo");
    dispatch({ type: USER_LOGIN_CLEAR_STATE });
    dispatch({ type: SET_SESSION_ID, payload: null });
    window.location.href = "/login";
  }
};

export const userRoleAction =
  (input, callback) => async (dispatch, getState) => {
    dispatch({
      type: USER_ROLE_REQUEST,
    });

    try {
      const { data } = await axiosInstance.get(
        "UserRole?filter=%5B%22id%22%2C1%5D&_=1709995526310"
      );
      dispatch({
        type: USER_ROLE_SUCCESS,
        payload: data,
      });
      console.log(data, "userRole");
      callback?.(true);
    } catch (error) {
      dispatch({
        type: USER_ROLE_FAIL,
        payload: error,
      });
      callback?.(true);
      console.log(error, "user role error");
    }
  };
